import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import { adminSegmentosEducativos, getSegmentosEducativos } from "../../Services/segmentos_educativos_service";

const initialState = {
    segmentosEducativos: [],
    segmentoEducativo: {
        nombre: '',
        estado: 1,
    },
}

export const segmentoEducativoSlice = createSlice({
    name: 'segmentoEducativo',
    initialState,
    reducers: {
        setSegmentosEducativos: (state, action) => {
            state.segmentosEducativos = action.payload;
        },
        setSegmentoEducativo: (state, action) => {
            state.segmentoEducativo = action.payload ?? initialState.segmentoEducativo;
        },
    }
});

export const fetchSegmentosEducativos = createAsyncThunk(
    'segmentosEducativos/fetchSegmentosEducativos',
    async (_, { dispatch }) => {
        const segmentosEducativosRes = await getSegmentosEducativos();
        dispatch(setSegmentosEducativos(segmentosEducativosRes));
    }
);

export const mergeSegmentoEducativo = createAsyncThunk(
    'segmentosEducativos/merge',
    async (data, {dispatch}) => {
        dispatch(setLoading(true))
        const segmentoEducativoRes = await adminSegmentosEducativos(data);
        dispatch(setResponse(segmentoEducativoRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchSegmentosEducativos());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setSegmentosEducativos, setSegmentoEducativo } = segmentoEducativoSlice.actions;
export default segmentoEducativoSlice.reducer;